module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/features-data-structure.json
// module id = 2097
// module chunks = 212354500165557